import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'eci-confirm-create',
  templateUrl: './confirm-create.component.html',
  styleUrls: ['./confirm-create.component.scss']
})
export class ConfirmCreateComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ConfirmCreateComponent>,
  ) { }

  ngOnInit(): void {
  }

  close(type){
    if(type == "success"){
      this.dialogRef.close("success");
    }else{
      this.dialogRef.close();
    }
  }

}
